/**
 * AppTabBar Component
 *
 * Tab bar di level aplikasi yang menampilkan semua halaman yang sedang terbuka.
 * Mirip dengan tab browser - setiap halaman dibuka sebagai tab baru.
 */

import { X } from 'lucide-react';
import { useAppTabsStore } from '@/stores/appTabsStore';
import './AppTabBar.css';

export function AppTabBar() {
  const { tabs, activeTabId, switchTab, closeTab } = useAppTabsStore();

  // Jangan render jika tidak ada tab
  if (tabs.length === 0) {
    return null;
  }

  const handleTabClick = (tabId: string) => {
    switchTab(tabId);
  };

  const handleCloseTab = (e: React.MouseEvent, tabId: string) => {
    e.stopPropagation(); // Prevent tab switch when clicking close button
    closeTab(tabId);
  };

  return (
    <div className="app-tab-bar">
      <div className="app-tab-list">
        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`app-tab ${tab.id === activeTabId ? 'active' : ''}`}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.icon && <span className="app-tab-icon">{tab.icon}</span>}
            <span className="app-tab-label">{tab.label}</span>
            <button
              className="app-tab-close"
              onClick={(e) => handleCloseTab(e, tab.id)}
              title="Tutup tab"
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
